module.exports = __webpack_public_path__ + "static/media/social-icon-linkedin-green.ddb11f69.svg";